module.exports = __webpack_public_path__ + "img/tagging-image-no.a3ac35ea.png";